import { render, staticRenderFns } from "./Inspeccion_Pac.vue?vue&type=template&id=ed28fb7c&scoped=true&"
import script from "./Inspeccion_Pac.vue?vue&type=script&lang=js&"
export * from "./Inspeccion_Pac.vue?vue&type=script&lang=js&"
import style0 from "./Inspeccion_Pac.vue?vue&type=style&index=0&id=ed28fb7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed28fb7c",
  null
  
)

export default component.exports